export * from './base-accordion.component';


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/base-accordion/index.ts